import { render, staticRenderFns } from "./RewardEditor.vue?vue&type=template&id=f801f632&"
import script from "./RewardEditor.vue?vue&type=script&lang=js&"
export * from "./RewardEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RewardEditor.vue"
export default component.exports